import React from 'react'
import styled from 'styled-components'
import addTransparencyToHex from '../../../utils/addTransparencyToHex/addTransparencyToHex'
import { useUiKitContext } from '../../../utils/UiKitProvider/UiKitProvider'
import LabeledDot, { type LabeledDotProps } from './LabeledDot'

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaQueries.tabletUp} {
    > :not(:last-child) {
      margin-right: 16px;
    }
  }
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    justify-content: space-between;
  }
`

const Title = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: ${({ theme }) => addTransparencyToHex(theme.palette.black, 70)};

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

export type DotStatus = 'valid' | 'dueSoon' | 'notValid' | 'notAssigned'

export type DotType = Omit<LabeledDotProps, 'label'> & { key: DotStatus }

export const dotsTypes: DotType[] = [
  {
    key: 'valid',
    colour: 'green'
  },
  {
    key: 'dueSoon',
    colour: 'orange'
  },
  {
    key: 'notValid',
    colour: 'red'
  },
  {
    key: 'notAssigned',
    colour: 'silver'
  }
]

// Move this in care-office
// this is not a reusable component
// todo
function Legend({ className }: { className?: string }) {
  const { translation: t } = useUiKitContext()

  return (
    <Wrapper className={className}>
      <Title>Legend:</Title>
      {dotsTypes.map((dot) => (
        <LabeledDot
          key={dot.key}
          colour={dot.colour}
          label={t(`skillsAndNeeds.dots.${dot.key}`)}
        />
      ))}
    </Wrapper>
  )
}

export default Legend
